"use client";

import { Wallet } from "lucide-react";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { useLazyAppKit } from "@/lib/lazy-appkit";

export const ConnectWalletPrompt: React.FC = () => {
  const t = useTranslations("feedback");
  const { open } = useLazyAppKit();

  return (
    <div className="bg-bg-secondary rounded-md max-w-xl mx-auto py-12 px-8 flex flex-col items-center text-center space-y-4 max-sm:py-8 max-sm:px-4">
      <Wallet className="size-16 text-text-secondary/40" />
      <h2 className="text-lg font-semibold text-text-primary">
        {t("connectWallet.title")}
      </h2>
      <p className="text-sm text-text-secondary leading-relaxed max-w-sm">
        {t("connectWallet.description")}
      </p>
      <Button variant="solid" colors="primary" size="lg" onClick={() => open()}>
        {t("connectWallet.button")}
      </Button>
    </div>
  );
};
